import { render, staticRenderFns } from "./ReferralGiftTeacher.vue?vue&type=template&id=7a3eeae4&scoped=true&"
import script from "./ReferralGiftTeacher.vue?vue&type=script&lang=js&"
export * from "./ReferralGiftTeacher.vue?vue&type=script&lang=js&"
import style0 from "./ReferralGiftTeacher.vue?vue&type=style&index=0&id=7a3eeae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3eeae4",
  null
  
)

export default component.exports